module.exports = __webpack_public_path__ + "media/images/shared/downloads/google-ff39eb49d54af4c6fbc7907996703666.png";